module.exports = __webpack_public_path__ + "img/newsdetails3.53612cae.png";